import { render, staticRenderFns } from "./ExpandView.vue?vue&type=template&id=3a245e68&"
import script from "./ExpandView.vue?vue&type=script&lang=js&"
export * from "./ExpandView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports